The name of the advertisement product, including any add-ons purchased alongside it.

Denotes `seekAdvertisementProducts` selection as a single human-readable name, e.g. `Branded Basic` or `Basic with Branding and Urgent Add-on`.
